/* ============================================================
   My Dorm Store — College Checklist live cart wiring (v2)
   FIXES:
   - Link clicks no longer navigate away (they tick the checkbox)
   - No more "open search in new tab" surprise behaviour
   - Lower matching threshold + substring fallback
   - Category fallback: items map to the relevant bundle product
   - Cart de-dupes so the same bundle isn't added twice
   ============================================================ */
// ===== PRINT-TO-PDF VIEW (global so the hero button can call it) =====
// Builds a clean, theme-free printable page in a new window/tab and auto-fires
// the browser print dialog, where "Save as PDF" is the default destination on
// macOS/iOS/Windows. No Shopify header, no footer, no theme styles — just the
// checklist on a clean letter-size sheet.
window.mdsOpenPrintView = function () {
  var win = window.open('', '_blank');
  if (!win) { alert('Please allow pop-ups for this site to print the checklist.'); return; }

  function esc(s) { return (s || '').replace(/[&<>"']/g, function (c) {
    return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c];
  }); }

  // Build the print body by walking the existing checklist DOM
  var sectionsHTML = '';
  document.querySelectorAll('.mds-cl .cat').forEach(function (cat) {
    var title = cat.querySelector('h2') ? cat.querySelector('h2').textContent.trim() : '';
    var blurb = cat.querySelector('.cat-blurb');
    var emoji = cat.querySelector('.cat-emoji');
    var emojiStr = emoji ? emoji.textContent.trim() : '';
    var liHTML = '';
    cat.querySelectorAll('.item').forEach(function (item) {
      var cb     = item.querySelector('input[type="checkbox"]');
      var nameEl = item.querySelector('a');
      var pro    = item.querySelector('.pro');
      var req    = item.querySelector('.req');
      var box    = cb && cb.checked ? '☑' : '☐';
      var tag    = pro ? ' <span class="tag tag-ess">essential</span>'
                 : req ? ' <span class="tag tag-req">required</span>' : '';
      liHTML += '<li><span class="box">' + box + '</span> ' + esc(nameEl ? nameEl.textContent.trim() : '') + tag + '</li>';
    });
    sectionsHTML +=
      '<section class="cat">' +
        '<h2><span class="emoji">' + esc(emojiStr) + '</span> ' + esc(title) + '</h2>' +
        (blurb ? '<p class="blurb">' + esc(blurb.textContent.trim()) + '</p>' : '') +
        '<ul>' + liHTML + '</ul>' +
      '</section>';
  });

  var todayStr = new Date().toLocaleDateString('en-CA', { year:'numeric', month:'long', day:'numeric' });

  var html = [
    '<!DOCTYPE html>',
    '<html lang="en"><head>',
    '<meta charset="UTF-8">',
    '<title>Dorm Checklist — My Dorm Store</title>',
    '<link rel="preconnect" href="https://fonts.googleapis.com">',
    '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>',
    '<link href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,700&family=Inter:wght@400;600;700&display=swap" rel="stylesheet">',
    '<style>',
    '  *,*:before,*:after{box-sizing:border-box}',
    '  html,body{margin:0;padding:0;background:#fff;color:#0b1f3a;font-family:Inter,system-ui,sans-serif;font-size:13px;line-height:1.4;}',
    '  .page{max-width:780px;margin:0 auto;padding:32px 36px 24px;}',
    '  .head{border-bottom:2px solid #00347d;padding-bottom:14px;margin-bottom:18px;display:flex;align-items:flex-end;justify-content:space-between;gap:16px}',
    '  .head h1{font-family:Fraunces,Georgia,serif;font-size:30px;color:#00347d;font-weight:700;margin:0;letter-spacing:-.02em;line-height:1}',
    '  .head .eyebrow{color:#dc4960;text-transform:uppercase;letter-spacing:.18em;font-size:10px;font-weight:700;margin-bottom:6px;}',
    '  .head .right{text-align:right;font-size:11px;color:#666;line-height:1.5}',
    '  .head .right strong{color:#00347d;display:block;font-family:Fraunces,Georgia,serif;font-size:14px;}',
    '  .lede{color:#444;font-size:13px;margin:0 0 22px;max-width:600px;}',
    '  .cat{page-break-inside:avoid;margin-bottom:18px;}',
    '  .cat h2{font-family:Fraunces,Georgia,serif;font-size:18px;color:#00347d;font-weight:700;margin:0 0 4px;letter-spacing:-.01em;border-bottom:1px solid #eaf6ff;padding-bottom:4px;}',
    '  .cat h2 .emoji{font-size:16px;margin-right:4px;}',
    '  .cat .blurb{font-size:11px;color:#666;margin:0 0 8px;font-style:italic;}',
    '  .cat ul{list-style:none;padding:0;margin:0;columns:2;column-gap:28px;}',
    '  .cat li{padding:5px 0;font-size:12.5px;break-inside:avoid;display:flex;align-items:flex-start;gap:6px;}',
    '  .cat .box{font-size:14px;line-height:1;color:#00347d;font-family:"Apple Symbols","Segoe UI Symbol",sans-serif;}',
    '  .tag{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;padding:1px 6px;border-radius:3px;margin-left:4px;vertical-align:middle;}',
    '  .tag-ess{background:#fde8ec;color:#dc4960;}',
    '  .tag-req{background:#00347d;color:#fff;}',
    '  footer{margin-top:28px;padding-top:12px;border-top:1px solid #eee;font-size:10px;color:#999;text-align:center;}',
    '  footer a{color:#00347d;text-decoration:none;}',
    '  @page{size:letter;margin:14mm;}',
    '  @media print{.page{padding:0;max-width:none;}.cat ul{columns:2;}}',
    '</style></head><body>',
    '<div class="page">',
      '<div class="head">',
        '<div><div class="eyebrow">My Dorm Store</div><h1>Your Dorm Checklist</h1></div>',
        '<div class="right"><strong>2026 – 2027</strong>Printed ' + esc(todayStr) + '</div>',
      '</div>',
      '<p class="lede">A room-by-room packing list for residence. Tick items off as you pack — or visit <a href="https://mydormstore.ca/pages/checklist">mydormstore.ca/pages/checklist</a> to add them straight to your cart.</p>',
      sectionsHTML,
      '<footer>Made with ❤️ in Ontario · <a href="https://mydormstore.ca">mydormstore.ca</a></footer>',
    '</div>',
    // The script tags below are split across string concatenation so the outer
    // HTML parser does not mistake them for the end of THIS surrounding script block.
    '<' + 'script>',
    '  function go(){ try{window.print();}catch(e){} }',
    '  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function(){setTimeout(go,250);}); }',
    '  else { window.addEventListener("load", function(){setTimeout(go,400);}); }',
    '</' + 'script>',
    '</body></html>'
  ].join('');

  win.document.open();
  win.document.write(html);
  win.document.close();
};

(function () {
  /* GUARD: only run on pages that actually contain the checklist */
  if (!document.querySelector(".mds-cl .item")) return;
  var SHOP = 'https://mydormstore.ca';
  var SAME = location.hostname.indexOf('mydormstore') !== -1;

  // ---- CATEGORY → DEFAULT PRODUCT HANDLE ----
  // When a checklist item has no direct product match, fall back to this bundle.
  // Edit any handle below to point to a different product on mydormstore.ca.
  var CATEGORY_HANDLES = {
    bedding:  'basic-bedding-essentials-copy-1',
    bath:     'bathroom-essentials-copy',
    laundry:  'laundry',
    tech:     'tech-essentials',
    decor:    'desk-essentials',
    living:   'cleaning-essentials-2',
    storage:  'organization-essentials',
    kitchen:  'basic-kitchen-essentials',
    wellness: null                        // care packages — let fuzzy match find each one
  };

  var checks      = document.querySelectorAll('.mds-cl .item input[type="checkbox"]');
  var fill        = document.getElementById('mdsFill');
  var checkedEl   = document.getElementById('mdsChecked');
  var totalEl     = document.getElementById('mdsTotal');
  var resetBtn    = document.getElementById('mdsReset');
  var toast       = document.getElementById('mdsToast');
  // Summary + sticky bar
  var sumLines    = document.getElementById('mdsSumLines');
  var sumTotal    = document.getElementById('mdsSumTotal');
  var addAllBtn   = document.getElementById('mdsAddAllBtn');
  var stickyBar   = document.getElementById('mdsStickyBar');
  var stickyCount = document.getElementById('mdsStickyCount');
  var stickyTotal = document.getElementById('mdsStickyTotal');
  var stickyBtn   = document.getElementById('mdsStickyBtn');

  totalEl.textContent = checks.length;

  // Tag every item with a clean query string (no on-row status badge — header already explains)
  Array.prototype.forEach.call(document.querySelectorAll('.mds-cl .item'), function (row, i) {
    var a = row.querySelector('a');
    if (!a) return;
    var q = a.textContent.trim().replace(/\s*\(.*?\)\s*$/, '').trim();
    row.dataset.query = q;
    row.dataset.index = i;
  });

  // INTERCEPT link clicks so they tick the checkbox instead of navigating
  document.querySelectorAll('.mds-cl .item a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      // Cmd/Ctrl/Shift/middle-click still opens the link in a new tab (sane default)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      var row = a.closest('.item');
      var cb  = row && row.querySelector('input[type="checkbox"]');
      if (cb) { cb.checked = !cb.checked; cb.dispatchEvent(new Event('change')); }
    });
  });

  // Local selection state — tracks ticks. Nothing goes to Shopify until "Add to cart" is clicked.
  // itemIdx -> { product, variantId, priceCents }
  var selections = {};

  function showToast(msg, isError) {
    toast.textContent = msg;
    toast.classList.toggle('error', !!isError);
    toast.classList.add('show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  // --- Fetch products.json (paginated) ---
  function fetchAll() {
    var products = [];
    function next(page) {
      return fetch(SHOP + '/products.json?limit=250&page=' + page, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          if (!d.products || !d.products.length) return products;
          products = products.concat(d.products);
          if (d.products.length < 250 || page >= 8) return products;
          return next(page + 1);
        })
        .catch(function () { return products; });
    }
    return next(1);
  }

  // --- Fuzzy match (more lenient than v1) ---
  var STOP = { a:1,an:1,the:1,and:1,or:1,of:1,for:1,with:1,set:1,pack:1,kit:1,x:1,'&':1,to:1,'in':1,on:1 };
  function tokens(s) {
    return (s || '').toLowerCase().replace(/[^\w\s]/g, ' ').split(/\s+/).filter(function (t) { return t && !STOP[t] && t.length > 1; });
  }
  function score(qt, title, tags) {
    var hay = (title + ' ' + (tags || []).join(' ')).toLowerCase();
    var ht = {};
    tokens(hay).forEach(function (t) { ht[t] = 1; });
    var hits = 0;
    qt.forEach(function (t) { if (ht[t]) hits++; });
    var s = qt.length ? hits / qt.length : 0;
    // Substring bonus: query whole phrase appears in title
    if (qt.length >= 2 && hay.indexOf(qt.join(' ')) !== -1) s = Math.max(s, 0.8);
    return s;
  }
  function bestMatch(q, products) {
    var qt = tokens(q); if (!qt.length) return null;
    var best = null, bestScore = 0.4;   // was 0.5
    for (var i = 0; i < products.length; i++) {
      var s = score(qt, products[i].title, products[i].tags);
      if (s > bestScore) { bestScore = s; best = products[i]; }
    }
    return best;
  }
  function findByHandle(products, handle) {
    if (!handle) return null;
    for (var i = 0; i < products.length; i++) {
      if (products[i].handle === handle) return products[i];
    }
    return null;
  }

  // --- BATCH ADD TO CART ---
  // Sends every selected unique variant to /cart/add.js in ONE request, then redirects to /checkout.
  // This sidesteps the per-tick theme-refresh problem entirely — Shopify renders the cart fresh
  // on the redirect target, so the user always sees up-to-date state.
  function batchAddAndCheckout() {
    var items = collectCartItems();
    if (!items.length) { showToast('Tick at least one item first', true); return; }

    addAllBtn.disabled = true; stickyBtn.disabled = true;
    var origLabel = stickyBtn.textContent;
    stickyBtn.textContent = 'Adding to cart…';

    if (!SAME) {
      // Cross-domain fallback: build a multi-item /cart/add URL (Shopify supports id=X&id=Y format)
      var qs = items.map(function (i) { return 'id=' + i.id + '&quantity=' + i.quantity; }).join('&');
      window.location.href = SHOP + '/cart/add?' + qs + '&return_to=/cart';
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function () { window.location.href = '/cart'; })
    .catch(function (err) {
      console.warn('Batch add failed', err);
      addAllBtn.disabled = false; stickyBtn.disabled = false;
      stickyBtn.textContent = origLabel;
      showToast('Could not add to cart — please try again', true);
    });
  }

  function collectCartItems() {
    // De-duplicate by variant id (each unique product line, quantity 1 — selecting multiple
    // checklist items that map to the same bundle still adds the bundle just once)
    var seen = {};
    Object.keys(selections).forEach(function (idx) {
      var s = selections[idx];
      if (s && s.variantId && !seen[s.variantId]) {
        seen[s.variantId] = { id: Number(s.variantId), quantity: 1 };
      }
    });
    return Object.keys(seen).map(function (k) { return seen[k]; });
  }

  // --- Progress ---
  function updateProgress() {
    var done = document.querySelectorAll('.mds-cl .item input[type="checkbox"]:checked').length;
    checkedEl.textContent = done;
    fill.style.width = (checks.length ? (done / checks.length * 100) : 0) + '%';
    document.querySelectorAll('.mds-cl .cat').forEach(function (cat) {
      var slug = cat.dataset.cat;
      var t = cat.querySelectorAll('input[type="checkbox"]').length;
      var d = cat.querySelectorAll('input[type="checkbox"]:checked').length;
      var tag = document.querySelector('.mds-cl .count[data-count="' + slug + '"]');
      if (tag) tag.textContent = d + '/' + t;
    });
  }

  // --- Update sidebar summary + sticky bar based on selections ---
  function updateSummary() {
    // De-duplicate by variant id (multiple checklist items pointing at the same bundle count once)
    var lines = {};
    Object.keys(selections).forEach(function (idx) {
      var s = selections[idx];
      if (s && s.variantId) lines[s.variantId] = s;
    });
    var lineKeys = Object.keys(lines);
    var lineCount = lineKeys.length;
    var totalCents = lineKeys.reduce(function (sum, vid) { return sum + (lines[vid].priceCents || 0); }, 0);
    var totalStr = money(totalCents);
    var hasAny = lineCount > 0;

    if (sumLines)    sumLines.textContent   = lineCount;
    if (sumTotal)    sumTotal.textContent   = totalStr;
    if (stickyCount) stickyCount.textContent = lineCount;
    if (stickyTotal) stickyTotal.textContent = totalStr;
    if (addAllBtn)   addAllBtn.disabled     = !hasAny;
    if (stickyBar)   stickyBar.classList.toggle('visible', hasAny);
  }

  // --- Wire items ---
  function attach(products) {
    document.querySelectorAll('.mds-cl .item').forEach(function (row) {
      var idx     = row.dataset.index;
      var cb      = row.querySelector('input[type="checkbox"]');
      var a       = row.querySelector('a');
      var query   = row.dataset.query;
      var catEl   = row.closest('.cat');
      var catSlug = catEl && catEl.dataset.cat;
      var pinnedHandle = row.dataset.handle;   // explicit product handle wins over fuzzy match

      // 1) Pinned handle
      var product = pinnedHandle ? findByHandle(products, pinnedHandle) : null;
      // 2) Fuzzy match by name
      if (!product && products && products.length) product = bestMatch(query, products);
      // 3) Category fallback bundle
      if (!product && catSlug && CATEGORY_HANDLES[catSlug]) {
        product = findByHandle(products, CATEGORY_HANDLES[catSlug]);
      }

      if (product) {
        a.href = SHOP + '/products/' + product.handle;
      } else {
        a.href = SHOP + '/search?q=' + encodeURIComponent(query);
      }

      cb.addEventListener('change', function () {
        updateProgress();
        if (cb.checked) {
          if (!product) {
            showToast('✓ Saved to your packing list');
            return;
          }
          var v = product.variants && product.variants[0];
          if (!v) return;
          selections[idx] = {
            product: product,
            variantId: String(v.id),
            priceCents: Math.round(parseFloat(v.price) * 100) || 0
          };
        } else {
          delete selections[idx];
        }
        updateSummary();
      });
    });
  }

  // Reset clears ticks + local selections (nothing in Shopify cart to undo, since we batch on click)
  resetBtn.addEventListener('click', function () {
    checks.forEach(function (c) { c.checked = false; });
    selections = {};
    updateProgress();
    updateSummary();
    showToast('List cleared');
  });

  // "Add to cart & checkout" buttons (sidebar + sticky bottom)
  if (addAllBtn) addAllBtn.addEventListener('click', batchAddAndCheckout);
  if (stickyBtn) stickyBtn.addEventListener('click', batchAddAndCheckout);

  // Boot
  fetchAll().then(function (products) {
    console.log('[Checklist] loaded ' + (products||[]).length + ' products from /products.json');
    if (!products || !products.length) {
      showToast('Could not load store products — checklist will work as a list only', true);
    }
    attach(products || []);
    updateProgress();
    updateSummary();
  });
})();